import type { Role } from '@miroom/shared';
import type { AuthApi, BoardsApi } from '../application/ports/api';
import type { BoardRepository, PresenceUser } from '../application/ports/board';
import { HttpAuthApi, HttpBoardsApi } from '../infrastructure/api/httpApi';

/** All external dependencies of the application layer. */
export interface Container {
  authApi: AuthApi;
  boardsApi: BoardsApi;
  /** Opens a live board; async so the realtime stack (Yjs) loads only with the board page. */
  connectBoard(boardId: string, role: Role, user: PresenceUser): Promise<BoardRepository>;
}

export function createHttpContainer(): Container {
  return {
    authApi: new HttpAuthApi(),
    boardsApi: new HttpBoardsApi(),
    connectBoard: async (id, role, user) =>
      (await import('../infrastructure/yjs/connectBoard')).connectBoard(id, role, user),
  };
}
